// Service layer for store-related HTTP requests.
// Keeps fetch/axios logic in one place.

import { get } from './http';

export async function fetchStore() {
  // use relative API route for production/proxy
  return get('/api/store', { credentials: 'include' });
}
